<template>
	<div class="timeBox" v-if="countdownShow">
		<span class="value" v-if="pageData.day > 0">{{ pageData.day }}</span><span class="label" v-if="pageData.day > 0">天</span>
		<span class="value">{{ pageData.hour }}</span><span class="label">:</span>
		<span class="value">{{ pageData.minute }}</span><span class="label">:</span>
		<span class="value">{{ pageData.second }}</span>
	</div>
	<div class="timeBox" v-else>
		<span class="value">0</span><span class="label">天</span>
		<span class="value">0</span><span class="label">:</span>
		<span class="value">0</span><span class="label">:</span>
		<span class="value">0</span>
	</div>
</template>

<script>
	export default {
		name: 'countdown',
		props: {
			time: {
//				type: Number,
				default() {
					return 0;
				}
			}
		},
		created() {
			this.interval = setInterval(() => {

				let endTime = this.time - (new Date() / 1000 | 0)
//			console.log(endTime)
				if(endTime <= 0) {
					clearInterval(this.interval)
					this.countdownShow = false
					this.$emit('countdownClose');
				}
				let date = {
					day: Math.floor(endTime / 86400),
					hour: Math.floor(endTime % 86400 / 3600),
					minute: Math.floor(endTime % 3600 / 60),
					second: Math.floor(endTime % 3600 % 60)
				}
				Object.keys(date).forEach(value => {
					if(date[value].toString().length < 2 && value !== 'day') {
						this.pageData[value] = "0" + date[value]
					} else {
						this.pageData[value] = date[value]
					}
				})
			}, 1000);
		},
		beforeDestroy() {
			clearInterval(this.interval)
		},
		data() {
			return {
				countdownShow: true,
				pageData: {
					day: '0',
					hour: '00',
					minute: '00',
					second: '00'
				}
			}
		}
	}
</script>
<style scoped>
	.timeBox {
		width: 100%;
		height: 60px;
		box-sizing: border-box;
		padding: 8px 0;
	}
	
	.value {
		padding: 0 3px;
		box-sizing: border-box;
		background-color: #000000;
		color: #ffffff;
		line-height: 44px;
		font-size: 24px;
		margin-left: 5px;
		border-radius: 5px;
	}
	
	.label {
		padding: 0 2px;
		box-sizing: border-box;
		color: #000000;
		line-height: 44px;
		font-size: 24px;
		margin-left: 5px;
	}
</style>